import React from "react";
import { Box, Container, Typography, Divider } from "@mui/material";
import logo from "../assets/dilliPay.png";
import { getFirmEmail } from "../theme/setThemeColor";

const CancellationPolicy = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        mt: 4,
        mb: 4,
        backgroundColor: "#fff",
        borderRadius: 3,
        boxShadow: 4,
        padding: { xs: 3, md: 6 },
        fontFamily: "Roboto, sans-serif",
        color: "#333",
      }}
    >
      {/* Logo and Header */}
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <img
          src={logo}
          alt="Dillipay Technologies Limited(DPTTerminalT)"
          style={{ width: "160px", marginBottom: "16px" }}
        />
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", color: "#004990", mb: 1 }}
        >
          DIillipay Technologies Limited(DPTTerminalT)
        </Typography>
        <Typography variant="body1" sx={{ color: "#000" }}>
          Corporate Address: Plot No. 5, Second Floor, Pocket -5, Rohini Sector
          24, New Delhi – 110085
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Title */}
      <Typography
        variant="h4"
        align="center"
        sx={{
          fontWeight: "bold",
          color: "#004990",
          mb: 3,
          pb: 0.5, // padding for spacing between text and underline
          borderBottom: "3px solid #004990", // underline effect
          display: "inline-block", // keeps underline only below text, not full width
        }}
      >
        DIillipay Technologies Limited(DPTTerminalT) Cancellation Policy
      </Typography>

      {/* Body Content */}
      <Box sx={{ textAlign: "left", lineHeight: 1.8, fontSize: "1rem" }}>
        <Typography paragraph sx={{ textAlign: "justify" }}>
          At DIillipay Technologies Limited(DPTTerminalT), we take API service
          delivery seriously and expect clients to fully understand the scope
          and terms of service before activation. Please read the following:
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: "bold", mt: 3 }}>
          1. No Cancellation after Activation
        </Typography>
        <Typography paragraph sx={{ textAlign: "justify" }}>
          Once an API service has been activated,{" "}
          <strong>cancellations are not permitted </strong>. Clients are
          strongly advised to thoroughly review service documentation, technical
          requirements, and compatibility before making any payments or
          proceeding with activation.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: "bold", mt: 3 }}>
          2. Contract-Based Services
        </Typography>
        <Typography paragraph sx={{ textAlign: "justify" }}>
          For services offered under a formal contract,{" "}
          <strong>
            cancellation terms and conditions will be clearly outlined in the
            signed agreement
          </strong>
          . Clients must refer to their specific agreement for details regarding
          notice periods, penalties, and refund eligibility.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: "bold", mt: 3 }}>
          3. Early Termination Fees
        </Typography>
        <Typography paragraph sx={{ textAlign: "justify" }}>
          If a client initiates cancellation{" "}
          <strong> before the end of a contractual term </strong>, they may be
          required to pay an <strong>early termination fee </strong>as defined
          in their service agreement.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: "bold", mt: 3 }}>
          4. Termination by Dillipay
        </Typography>
        <Typography paragraph sx={{ textAlign: "justify" }}>
          DIillipay Technologies Limited(DPTTerminalT) reserves the right to
          suspend or terminate API services without prior notice if the client:
        </Typography>

        <ul style={{ marginLeft: "2rem", lineHeight: 1.8 }}>
          <li>
            Violates the <strong>Terms of Service </strong>
          </li>
          <li>
            Engages in{" "}
            <strong>fraudulent, illegal, or unethical activities</strong>
          </li>
          <li>
            <strong>Misuses or abuses the API </strong>, affecting system
            performance or security
          </li>
        </ul>

        <Typography variant="h5" sx={{ fontWeight: "bold", mt: 3 }}>
          5. Refund Policy
        </Typography>
        <Typography paragraph sx={{ textAlign: "justify" }}>
          In the event of termination due to policy violations or misuse,
          <strong> no refunds</strong> will be issued. In exceptional cases,
          refund eligibility will be{" "}
          <strong>
            determined solely at the discretion of DILLIPAY TECHNOLOGIES
            LIMITED(DPTTerminalT){" "}
          </strong>
          .
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: "bold", mt: 3 }}>
          6. Final Note
        </Typography>
        <Typography paragraph sx={{ textAlign: "justify" }}>
          By activating or integrating with Dillipay's API services, clients
          agree to abide by this cancellation policy along with all applicable
          terms of use and service-level agreements.
        </Typography>

        <Divider sx={{ my: 3 }} />
        <Typography
          variant="h6"
          sx={{ mt: 3, fontWeight: "bold", lineHeight: 1.8 }}
        >
          For questions or clarification, please contact:
          <br />
          📧 {getFirmEmail()}
          <br />
          🌐 www.dillipay.com
          <br />
          📞 9355080884
        </Typography>
      </Box>
    </Container>
  );
};

export default CancellationPolicy;
